import { createMuiTheme, makeStyles, Theme, createStyles } from '@material-ui/core';

export const patrimoniumTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#8DD9C8',
            contrastText: '#fff',
        },
        secondary: {
            main: '#C94628',
            contrastText: '#fff',
        },
        info: {
            main: '#0c243a',
            contrastText: '#fff',
        },
    },
    overrides: {
        MuiSvgIcon: {
            root: { width: 17, height: 17 },
        },
    },
});

export const useGlobalStyles = makeStyles((theme: Theme) =>
    createStyles({
        iconButton: {
            width: 27,
            height: 27,
            borderRadius: 5,

            '& .k-icon': {
                width: 17,
                height: 17,
                fontSize: 17,
            },
        },
        iconButton_variantPrimary: {
            backgroundColor: `${theme.palette.primary.main} !important`,
            borderColor: `${theme.palette.primary.main} !important`,
        },
        iconButton_variantSecondary: {
            backgroundColor: `${theme.palette.secondary.main} !important`,
            borderColor: `${theme.palette.secondary.main} !important`,
        },
        iconButton_variantNeutral: {
            backgroundColor: `${theme.palette.info.main} !important`,
            borderColor: `${theme.palette.info.main} !important`,
        },
        iconButton_sizeLarge: {
            width: 30,
            height: 30,

            '& .k-icon': {
                width: 22,
                height: 22,
                fontSize: 22,
            },
        },
        iconButton_sizeSmall: {
            width: 23,
            height: 23,

            '& .k-icon': {
                width: 15,
                height: 15,
                fontSize: 15,
            },
        },
        iconButton_rounded: { borderRadius: '50%' },
        button_variantPrimary: {
            color: theme.palette.primary.main,
        },
        grid: {
            '& th:last-of-type': {},
            '& td:last-of-type': {},

            '& .k-grid-toolbar': {
                backgroundColor: '#c94628 !important',
                color: 'white',
                padding: '4px 4px',
            },
            '& .k-grid-header': {
                backgroundColor: '#0D273E !important',
                color: '#c6c6c6 !important',
                border: `1px solid`,
                borderColor: 'rgba(224, 224, 224, 1)',

                '& .k-sorted': {
                    color: '#c6c6c6',
                },

                '& .k-i-more-vertical': {
                    '&::before': {
                        content: `"\\e129"`,
                    },
                },

                '& .k-link': {
                    fontSize: '1em',

                    '& .k-icon': {
                        color: '#c6c6c6',
                    },

                    '&:hover': {
                        color: '#c6c6c6',
                    },
                },

                '& th': {
                    color: '#c6c6c6 !important',
                },

                '& .k-header': {
                    borderColor: 'rgba(224, 224, 224, 1)',
                    padding: '5px 24px',

                    '&:last-child': {
                        borderRight: '1px solid',
                    },
                },
                '& td': {
                    paddingTop: 3,
                    paddingBottom: 3,
                },

                '& .k-filter-row': {
                    '& th': {
                        borderColor: 'rgba(224, 224, 224, 1)',
                        padding: '5px 8px',

                        '&:last-child': {
                            borderRight: '1px solid',
                        },
                    },
                },
            },
            '& .k-header': {
                padding: '4px 4px',

                '& .k-link': {
                    paddingLeft: 8,
                },
            },
            '& .k-master-row': {
                fontSize: '13px',

                '&:nth-of-type(even)': {
                    backgroundColor: theme.palette.action.hover,
                },

                '&:hover': {
                    backgroundColor: '#eaeaee',
                },

                '& td': {
                    padding: '3px 8px',
                },

                '& td + td': {
                    borderLeft: `1px solid rgba(224, 224, 224, 1);`,
                },

                '&.k-state-selected': {
                    backgroundColor: 'rgb(13, 39, 62, 0.25);',
                },
            },
            '& .k-filter-row': {
                '& .k-filtercell': {
                    '& input': {
                        fontSize: '13px',
                        lineHeight: 1,
                    },
                    '& .k-textbox': {
                        color: theme.palette.info.main,
                        borderColor: theme.palette.grey[400],
                        border: '1.5px solid',
                        padding: theme.spacing(0, 1),
                        borderRadius: '5px',
                        backgroundColor: theme.palette.grey[300],
                        boxShadow: '3px 3px 5px 0px black',
                    },
                    '& .k-filtercell-operator': {
                        '& .k-select': {
                            color: 'white !important',
                        },
                    },
                },
            },
            '& .k-pager-numbers .k-link': {
                color: theme.palette.primary.main,

                '&:hover': {
                    backgroundColor: 'rgb(141, 217, 200, 0.11)',
                },
            },
            '& .k-pager-numbers .k-link.k-state-selected': {
                color: theme.palette.primary.main,
                backgroundColor: 'rgb(141, 217, 200, 0.22)',
            },
        },
        dialog: {
            top: '-5vh',

            '& .k-dialog': {
                '& .k-dialog-content': {
                    marginTop: theme.spacing(2),
                    // eslint-disable-next-line no-restricted-globals
                    maxHeight: screen.height / 2,
                },

                '& .k-dialog-titlebar': {
                    backgroundColor: theme.palette.secondary.main,
                    color: theme.palette.secondary.contrastText,
                    padding: '5px',
                },
                '& .k-form-buttons': {
                    justifyContent: 'flex-end',
                },
                '& .k-window-title': {
                    fontSize: '18px',
                },
                '& .k-step-label': {
                    '& .k-step-text': {
                        display: 'block',
                        whiteSpace: 'normal',
                    },
                },
            },
        },
        dialog_fixedHeight: {
            top: '-5vh',

            '& .k-dialog': {
                height: 600,
            },
        },
        dialog_sizeLarge: {
            top: '-5vh',
            '& .k-dialog': {
                width: '85vw',
            },
        },
        grid_link: {
            color: '-webkit-link',
            textDecoration: 'underline',
        },
        default_textarea: {
            width: '90%',
        },
        dialog_largeHeight: {
            top: '-5vh',

            '& .k-dialog': {
                '& .k-dialog-content': {
                    maxHeight: 700,
                },
            },
        },
    }),
);
